import BaseInteraction from './base';
import ScrollBarInteraction from './scrollbar';
import SliderInteraction from './slider';

BaseInteraction.registerInteraction('slider', SliderInteraction);
BaseInteraction.registerInteraction('scrollbar', ScrollBarInteraction);

export * from './base';
export default BaseInteraction;
